import { onMounted, onUnmounted, ref } from 'vue';

export default function useTimeInterval(executionInterval: number = 5000) {
  const interval = ref(0)
  const shouldStopInterval = ref(false)

  const startWatching = (execute: () => void) => {
    interval.value = setInterval(() => {
      if (shouldStopInterval.value) {
        return clearInterval(interval.value)
      }
      execute()
    }, executionInterval);
  }
  onUnmounted(() => {
    clearInterval(interval.value)
    console.log('onUnmounted shouldStopInterval', shouldStopInterval)
  })

  return {
    shouldStopInterval,
    startWatching,
  }
}